export interface TaskLibraryItem {
    area: string
    num: number
    goal: string
    task: string
    formulation: string
    explanation: string
    comments: string
}

export const TASK_LIBRARY: TaskLibraryItem[] = [
    {
        "area": "HR",
        "num": 1,
        "goal": "укомплектация штатного\nрасписания",
        "task": "Обрабатывать входящие звонки и\nсообщения с помощью подготовленных\nопросников и скриптов.\n1. Первичная квалификация кандидата\nчерез вопросы.\n2. Продажа вакансии подходящим\nкандидатам для повышения мотивации\nприйти на вторичное собеседование.\n3. Запись на вторичное собеседование.",
        "formulation": "Вариант1:\nЗапись на повторное\nсобеседование, %",
        "explanation": "% от обратившихся за день\nкандидатов, соответсвующих\nпрофилю",
        "comments": "Можно использовать этот показатель, если количество дневных обращений нестабильно, а\nзадача администратора отвечать на звонки от кандидатов стоит на 2 или 3 месте по важности."
    },
    {
        "area": "HR",
        "num": 2,
        "goal": "укомплектация штатного\nрасписания",
        "task": "Обрабатывать входящие звонки и\nсообщения с помощью подготовленных\nопросников и скриптов.\n1. Первичная квалификация кандидата\nчерез вопросы.\n2. Продажа вакансии подходящим\nкандидатам для повышения мотивации\nприйти на вторичное собеседование.\n3. Запись на вторичное собеседование.",
        "formulation": "Вариант 2:\nЗапись на повторное\nсобеседование, шт",
        "explanation": "Всего Y кандидатов,\nсоответсвующих профилю,\nзаписано в CRM",
        "comments": "Ставим, если нужно обработать много резюме за день и связаться с кандидатами. Или если\nполучаем много заявок ежедневно, но есть ограничение на максимальное число повторных\nсобеседований в день."
    },
    {
        "area": "HR",
        "num": 3,
        "goal": "укомплектация штатного\nрасписания",
        "task": "увеличить процент доходимости до\nповторного собеседования с ХХ до YY%\nчерез улучшение качества работы со\nскриптом",
        "formulation": "Вариант 3:\nдоходимость до\nповторного\nсобеседования, %",
        "explanation": "% от записанных на\nповторное собеседование",
        "comments": "Стоит использовать, если мы получаем много качественных звонков от кандидатов, но нужно\nповысить конверсию в доходимость до второго собеседования."
    },
    {
        "area": "HR",
        "num": 4,
        "goal": "Автоматизировать процесс\nадаптации нового\nсотрудника и обучение\nкорпоративным стандартам.\nБыстро вывести нового\nсотрудника на полную\nпродуктивность.",
        "task": "Обучить нового сотрудника стандартам\nкомпании, поддерживать его в период\nстажировки и подготовить к итоговому\nтесту по завершении испытательного\nсрока.",
        "formulation": "Оценка качества\nпроведения стажировки,\nбаллы",
        "explanation": "1-неудовлетворительно,\n2-требует улучшения,\n3-полностью соответствует\nожиданиям,\n4-превосходит ожидания,\n5-значительно превосходит\nожидания.",
        "comments": "Оценка качества стажировки нового сотрудника. Проставляет руководитель.\nНеобходим чек-лист стажировки, подготовленные тесты, аттестационные листы и пр.\nКак оцениваем (пример):\n- Соответствие графику изучения информационных блоков.\n- Результаты промежуточных и финальных тестов.\n- Увольнение до завершения испытательного срока по желанию сотрудника.\n- Наличие \"пробелов\" в знаниях по итогам тестов.\nОценка по пятибалльной шкале:\n1 - Неудовлетворительно.\n2 - Требуется улучшение.\n3 - Полностью соответствует ожиданиям. Является нормой!\n4 - Превосходит ожидания.\n5 - Значительно превосходит ожидания."
    },
    {
        "area": "продажи",
        "num": 5,
        "goal": "Повышение эффективности\nобработки запросов\nпотенциальных клиентов\nприводит к росту новых\nклиентов в кресле",
        "task": "увеличить процент конверсии входящих\nобращений в запись с ХХ до YY%",
        "formulation": "Конверсия в запись, %",
        "explanation": "% от всех входящих звонков и\nобращений за день",
        "comments": "Ставьте, если у вас много входящих обращений от клиентов, но мало записей после них. Нужно\nулучшить технику продаж, доработать скрипты входящих звонков и промо-предложения.\nДля контроля выполнения задачи желательна API-телефония и доступ к мессенджерам."
    },
    {
        "area": "продажи",
        "num": 6,
        "goal": "Повышение эффективности\nработы с постоянными\nклиентами сокращает\nпотерю базы и увеличивает\nLTV.",
        "task": "увеличить процент оперативных записей\n(ОПЗ, запись после услуги на следующий\nвизит)",
        "formulation": "Вариант 1:\nОПЗ, кл",
        "explanation": "количество клиентов\nзаписаных на следующий\nвизит сразу после услуги",
        "comments": "Мотивируем Администратора, чтобы у клиента сформировалась устойчивая привычка\nзаписываться на следующий визит.\nЭта задача может быть в списке плановых задач с наибольшим приоритетом."
    },
    {
        "area": "продажи",
        "num": 7,
        "goal": "Повышение эффективности\nработы с постоянными\nклиентами сокращает\nпотерю базы и увеличивает\nLTV.",
        "task": "увеличить процент оперативных записей\n(ОПЗ, запись после услуги на следующий\nвизит)",
        "formulation": "Вариант 2:\nОПЗ, руб",
        "explanation": "на какую сумму в руб.\nзаписано на следующий визит\nсразу после услуги",
        "comments": ""
    },
    {
        "area": "продажи",
        "num": 8,
        "goal": "Повышение эффективности\nработы с постоянными\nклиентами сокращает\nпотерю базы и увеличивает\nLTV.",
        "task": "увеличить процент оперативных записей\n(ОПЗ, запись после услуги на следующий\nвизит)",
        "formulation": "Вариант 3:\nОПЗ, % от числа всех\nобслуженных клиентов за\nдень",
        "explanation": "% количества клиентов от\nчисла всех обслуженных за\nдень",
        "comments": ""
    },
    {
        "area": "продажи",
        "num": 9,
        "goal": "Повышение эффективности\nработы с постоянными\nклиентами сокращает\nпотерю базы и увеличивает\nLTV.",
        "task": "увеличить процент оперативных записей\n(ОПЗ, запись после услуги на следующий\nвизит) на конкретную категорию\nуслуг",
        "formulation": "ОПЗ категория N, руб",
        "explanation": "на какую сумму в руб.\nзаписано на следующий визит\nсразу после услуги на N\nкатегорию услуг",
        "comments": "Например: появилась новая услуга или сильно отстает в плане - необходимо увеличить\nколичество записей. Записываем клиента на ту категорию услуг, которую необходимо усилить\nОПЗ Nail\nОПЗ Massage"
    },
    {
        "area": "продажи",
        "num": 10,
        "goal": "увеличить возвратность\nновых клиентов",
        "task": "Перезаписать на второй визит Нового\nКлиента (НК), пришедшего впервые",
        "formulation": "ОПЗ НК, %",
        "explanation": "% оперативной записи новых\nклиентов сразу после услуги",
        "comments": "Можно дополнительно использовать 10-15% скидку для стимуляции клиента на ОПЗ.\nВажно:\n1. чтобы ставить эту задачу, необходимо четко ставить план по количеству новых клиентов за\nпериод/день (план НК), соответственно должен быть регулярный приток НК\n2. если каждый день нет прихода НК, задачу ставить с учетом дальнейшего премирования или не\nставить вообще"
    },
    {
        "area": "продажи",
        "num": 11,
        "goal": "Увеличить LTV",
        "task": "Если в маркетинговой стратегии салона\nесть флагманская услуга, она становится\nосновой для привлечения клиентов и\nувеличения их лояльности. С помощью\nэтой услуги и дополнительных\nпредложений можно стимулировать\nповторные записи и расширять спектр\nуслуг, которые клиент будет готов\nприобрести.",
        "formulation": "ОПЗ с услуги N, %",
        "explanation": "% Конверсии клиентов после\nуслуги \"N\" в ОПЗ любой\nдругой услуги",
        "comments": "Можно предложить клиенту скидку 10-15%, чтобы стимулировать его на ОПЗ.\nЕсли CRM позволяет, стоит добавить идентификатор при переносе клиентов с услуги N на другие.\nЭто упростит последующую выгрузку данных аналитики о количестве записанных клиентов."
    },
    {
        "area": "продажи",
        "num": 12,
        "goal": "1.увеличить возвратность\nновых клиентов.\n2. Увеличить выручку с\nклиента через управляемые\nкросс продажи на услугу \"N\"",
        "task": "впервые пришедшего нового клиента по\nофферу клиента после услуги \"Х\"\nперезаписать во второй визит на другую\nуслугу \"N\"",
        "formulation": "ОПЗ НК с услуги Х на\nуслугу N, %",
        "explanation": "% новых клиентов после\nоказанной услуги \"Х\" в ОПЗ\nна услугу \"N\"",
        "comments": "Можно использовать оффер на привлечение НК \"кэшбэк 50% с услуги Х.\nВ каждом последующем визите кэшбэком можно оплатить 20% услуги Y\".\nЕсли возможности настрйки CRM позволяют, лучше использовать какой-то индентификатор для\nлегкой последующей аналитики"
    },
    {
        "area": "продажи",
        "num": 13,
        "goal": "Повышение эффективности\nработы с существующей\nклиентской базой",
        "task": "Увеличить ежедневную оперативную и\nвходящую запись с XXХХ до YYYY рублей.",
        "formulation": "Новые записи, руб.",
        "explanation": "Создание новых записей на\nлюбой день в течении смены\n(ОПЗ + входящие заявки)",
        "comments": "Мотивируем Администратора делать как можно больше записей в CRM\nУчитываются все входщие заявки на запись ( звонки, переписки), пересадка клиента с услуги на\nуслугу. Учитываются созднанные записи в течении смены, даже, если услугу сегодня уже оказали."
    },
    {
        "area": "продажи",
        "num": 14,
        "goal": "Повышение эффективности\nработы с существующей\nклиентской базой",
        "task": "увеличение записи клиентов на услугу N c\nXXX до YYY руб в смену",
        "formulation": "Новые записи, категория\nN, руб",
        "explanation": "Создание новых записей на\nлюбой день в течении смены\n(ОПЗ + входящие заявки) на N\nкатегорию услуг",
        "comments": "создает сверх-фокус на услуге или категории услуг, которую нужно продвигать.\nНапример:\nНовые записи Nail (выбираем какие услуги нам важно прокачать)\nНовые записи Massage (выбираем какие услуги нам важно прокачать)"
    },
    {
        "area": "продажи",
        "num": 15,
        "goal": "Повышение эффективности\nработы с существующей\nклиентской базой",
        "task": "увеличение продаж\nтоваров/абонементов/сертификатов",
        "formulation": "Товары/абонементы, руб",
        "explanation": "плановая выручка с продажи\nтоваров YYруб за день",
        "comments": "фокус на продажах товаров, абонементов, сертификатов.\nВажно:\nВ выпдающем списке задач есть \"Товары, руб\". В данном случае подтягиваются только сумма\nвыручки по товарам (без абонементов и сертификатов), т.к. система"
    },
    {
        "area": "продажи",
        "num": 16,
        "goal": "увеличение среднего чека с\nклиента",
        "task": "повысить сумму среднего чека с клиента\nс ХХХХ до YYYY руб",
        "formulation": "Ср. чек, руб",
        "explanation": "средний чек с клиента за\nсмену YYYY руб",
        "comments": "Лучше сочетать эту задачу с целью увеличить количество записей, например, с задачей #5.\nТакая формулировка учитывает как текущие результаты, так и действия другого администратора\nпо записи клиента на этот день.\nЕсли хотите избежать неопределенности, рассмотрите задачу #12."
    },
    {
        "area": "продажи",
        "num": 17,
        "goal": "увеличение среднего чека с\nклиента",
        "task": "Увеличить средний чек клиента при\nоформлении нового визита или услуги в\nтот же день с XXXX до YYYY рублей.",
        "formulation": "Ср. чек в новой записи,\nруб",
        "explanation": "средний чек с клиента по\nсозданным за смену новым\nзаписям (из-под логина\nАдминистратора) YYYY руб",
        "comments": "хорошо работает в связке с задачей на увеличение объема записей, например задача #8."
    },
    {
        "area": "продажи",
        "num": 18,
        "goal": "развитие канала\nрекомендаций для\nпривлечения новых\nклиентов",
        "task": "Каждому клиенту, получившему услугу,\nвыдавать зарегистрированный купон на\nскидку для нового клиента, которого он\nприведет по рекомендации.",
        "formulation": "Вариант 1:\nКупоны, шт",
        "explanation": "выдать Y шт купонов в день",
        "comments": "Применять на старте программы рекомендаций (риферальной).\nПри регистрации купонов нужно указывать имя администратора, который выдал их клиенту. Это\nпозволит отслеживать количество купонов, выданных каждым администратором отдельно."
    },
    {
        "area": "продажи",
        "num": 19,
        "goal": "развитие канала\nрекомендаций для\nпривлечения новых\nклиентов",
        "task": "Каждому клиенту, получившему услугу,\nвыдавать зарегистрированный купон на\nскидку для нового клиента, которого он\nприведет по рекомендации.",
        "formulation": "Вариант 2:\nКупоны, %",
        "explanation": "% розданных купонов с\nрекомендацией от чистла\nклиентов за смену",
        "comments": "Для повышения эффективности программы рекомендаций нужно выдавать купоны самым\nлояльным клиентам, которые довольны услугой и сервисом. При этом важно \"квалифицировать\"\nклиента. Рекомендуется использовать методику NPS.\nПри регистрации купонов нужно указывать имя администратора, который выдал их клиенту. Это\nпозволит отслеживать количество купонов, выданных каждым администратором отдельно."
    },
    {
        "area": "продажи",
        "num": 20,
        "goal": "развитие канала\nрекомендаций для\nпривлечения новых\nклиентов",
        "task": "Мотивировать Администратора на\nактивное взаимодействие с клиентами-\nрекомендателями.\nУвеличить количество новых клиентов,\nпришедших по рекомендациям, с 0.X до 0.\nY в смену.",
        "formulation": "Рекомендации, кл",
        "explanation": "принять по купону\n\"рекомендации\" Y клиентов в\nсмену",
        "comments": "При регистрации купонов нужно указывать имя администратора, который выдал их клиенту. Это\nпозволит отслеживать количество купонов, выданных каждым администратором отдельно."
    },
    {
        "area": "продажи",
        "num": 21,
        "goal": "увеличение дневной\nвыручки",
        "task": "Повысить дневную выручку за счет\nдополнительных услуг, товаров и записей\nна обслуживание в тот же день.",
        "formulation": "Прирост выручки, руб",
        "explanation": "план по приросту дневной\nвыручки к имеющейся на\nначало смены в CRM записи\n+YYYY руб/день",
        "comments": "данная задача стимулирует прирост дневной выручки за счет допродаж услуг и товаров.\nСчитается как сумма прироста в руб. от суммы на начало смены."
    },
    {
        "area": "продажи",
        "num": 22,
        "goal": "улучшение качества записи",
        "task": "снизить показатель отмен записи с 25 до\n20% от всех записей, сделанных из-под\nлогина конкретного Администратора",
        "formulation": "Клиент пришел, %",
        "explanation": "% клиентов со статусом\n\"клиент пришел\" от всех\nзапланированных записей за\nдень",
        "comments": "Ставить эту задачу целесообразно, если процент отмен растет быстрее выручки. Также стоит\nзадуматься, если много некачественных записей заполняют все свободные слоты, мешая записи\nклиентов."
    },
    {
        "area": "продажи",
        "num": 23,
        "goal": "возврат клиентской базы",
        "task": "Стимулировать Администратора на\nсистематическую работу с клиентской\nбазой, которая теряет активность, и\nвернуть клиентов на сумму YYYY руб в\nсмену.",
        "formulation": "Работа с базой, руб",
        "explanation": "запись клиентов из списка\nдля реанимации на сумму\nYYYY руб",
        "comments": "Мотивация для системной реанимации остывающих клиентов. Можно органично интегрировать\nэто в регулярные задачи администратора. Предоставлять обновляемый список для обзвона,\nчтобы администратор звонил и писал сообщения клиенту. Необходимы скрипты и обучение\nменеджера."
    },
    {
        "area": "продажи",
        "num": 24,
        "goal": "Увеличить доход от клиента\nили повысить возвратность\nблагодаря автоматическому\nконтролю за\nиспользованием промо-\nинструментов",
        "task": "Стимулировать регулярное\nиспользование промо-инструмента\nАдминистраторами для увеличения\nвыручки.",
        "formulation": "ОПЗ промо, кл",
        "explanation": "Перезапись клиента сразу\nпосле услуги по промо-\nинструменту, кл",
        "comments": "создать отдельную позицию или маркер для идентификации услуги, не через комментарий к\nзаписи.\n2. Разработать скрипт для администраторов и POSM для ресепшена, а также провести рассылку\nдля разогрева интереса.\n3. Направить усилия администраторов на активное использование промо-инструмента с помощью\nзадачи. Улучшить скрипт и контролировать его выполнение, чтобы увеличить количество\nклиентов, которым продано промо-предложение (выгрузка из CRM).\n4. Если CRM позволяет оперативно сегментировать и формировать отчет по клиентам за смену,\nподходящим под использование промо-инструментов, лучше поставить цель в процентах.\nНапример, в случае с «Комбо маникюр с покрытием + педикюр» задача может звучать так:\n«Продать педикюр 50% клиентам, прошедших через маникюр»."
    },
    {
        "area": "продажи",
        "num": 25,
        "goal": "Увеличить доход от клиента\nили повысить возвратность\nблагодаря автоматическому\nконтролю за\nиспользованием промо-\nинструментов",
        "task": "Стимулировать регулярное\nиспользование промо-инструмента\nАдминистраторами для увеличения\nвыручки.",
        "formulation": "ОПЗ промо, %",
        "explanation": "% перезаписи клиента сразу\nпосле услуги по промо-\nинструменту, кл",
        "comments": ""
    },
    {
        "area": "сервис",
        "num": 26,
        "goal": "Повышение уровня\nудовлетворенности\nклиентов (показатель NPS)\nснижает их отток.",
        "task": "Мотивировать Администратора на\nпредоставление клиенту высокого\nсервиса и клиентоориентированности от\nвсех сотрудников смены. Увеличить\nпоказатель NPS с XX до YY% за смену.",
        "formulation": "NPS смены, %",
        "explanation": "% NPS по обслуженным за\nсмену клиентам",
        "comments": "Для корректного замера NPS без искажения данных Администратором можно использовать\nследующие методы:\n1. Авторассылки после услуги с запросом отзыва с выводом ответа на гугл-форму.\n2. Звонок управляющего или владельца с проверкой качества и замером NPS.\n3. Анкетирование.\n4. Метрики из CRM (если система это поддерживает)."
    },
    {
        "area": "сервис, продукт",
        "num": 27,
        "goal": "понимание уровня\nудовлетворенности\nклиентов. Выявление\nсильных сторон и зон\nразвития.",
        "task": "Измерить уровень удовлетворенности\nклиентов после посещения салона или\nсразу после оказания услуги мастером.\nУвеличить количество анкетируемых с XX\nдо YY клиентов за смену.",
        "formulation": "Анкетирование, кл",
        "explanation": "проанкетировать и принять у\nклиентов YY анкет за смену",
        "comments": "Измерение показателя NPS и определение факторов, которые нравятся или не устраивают\nклиентов. Администратор не должен быть заинтересован в завышении оценки, чтобы не исказить\nобъективную картину. Анкетирование может быть анонимным, а контактные данные можно\nоставить по желанию, чтобы при необходимости связаться для решения проблемы."
    },
    {
        "area": "сервис, продукт",
        "num": 28,
        "goal": "Обеспечить соответствие\nфактического состояния\nсалона требованиям,\nуказанным в чек-листе\nСервис",
        "task": "Проверить соответствие салона\nключевым критериям с помощью\nуправляющего или внешнего\nспециалиста — тайного покупателя.",
        "formulation": "Сервис, %",
        "explanation": "Факт (баллов) / План (баллов)\n= % выполнения.",
        "comments": "ключевые для клиента критерии для повторного выбора зафиксировать в чек листе: чистота\nповерхностей, санузла, пола; униформа сотрудников; скрипт корпоративного приветствия и\nсоблюдение установленных ритуалов в работе с гостем и проч.\nКаждому пункту чек-листа присвойте баллы. Затем сравните фактические и плановые баллы"
    },
    {
        "area": "продукт",
        "num": 29,
        "goal": "внедрение технологии\nуправления качеством",
        "task": "Повысить контроль администратора за\nкачеством услуг. Сократить количество\nрекламаций с Х% до 0,Х% от всех\nпредоставленных услуг за смену.\n(значения приведены для примера).",
        "formulation": "Контроль Качества, %",
        "explanation": "показатель качества работы\nмастеров за смену 99.5% (100-\n0.5%) от числа обслуженных\nза смену клиентов",
        "comments": "Эффективно использовать задачу при низком и среднем качестве услуг. Цель - сократить\nколичество жалоб на некачественное обслуживание до 0,5% от общего числа оказанных услуг.\nЕсли клиент предъявляет претензию в течение гарантийного срока - пересмотреть работу\nадминистратора, который обслуживал его в тот день.\nТакже можно использовать для контроля качества сервиса Администратора."
    },
    {
        "area": "маркетинг",
        "num": 30,
        "goal": "развитие репутации в\nотзовиках и\nкартографических сервисах",
        "task": "увеличить кол-во 5* отзывов в\nприоритетных каналах (Яндекс Карты,\n2ГИС, Google map и т.д.) с X до Y за день",
        "formulation": "Отзывы, шт",
        "explanation": "ежденевнай план по\nразмещенным клиентским\nотзывам за смену Y шт",
        "comments": "Нужно точно привязывать результаты работы к смене, в которую обслужен клиент. Но эти усилия\nоправданы, так как публичный отзыв клиента значительно укрепляет репутацию салона.\nЧтобы дополнительно стимулировать клиентов оставлять отзывы, можно запустить промо-\nинструмент в виде бонусов или скидок для лояльных клиентов за размещение отзыва."
    },
    {
        "area": "маркетинг",
        "num": 31,
        "goal": "Обеспечение контентом\nSMM-специалиста, который\nработает с аккаунтом..",
        "task": "Создать фотобанк работ мастеров\nсалона, который будет формировать\nленту аккаунта. Также регулярно\nпубликовать сторис в Instagram.",
        "formulation": "Контент, баллы",
        "explanation": "план по созданию контента Y\nбаллов ежедневно",
        "comments": "Учет контента:\n- Фото, соответствующие стандартам, оцениваются в 1 балл.\n- Сторис также получают 1 балл.\n- Видеоотзыв клиента приносит 2 балла.\nМетрика в баллах объединяет разные показатели в один, что позволяет не устанавливать\nотдельные планы для сторис, фото и видеоотзывов.\nВозможно установить план в количестве шт."
    },
    {
        "area": "маркетинг",
        "num": 32,
        "goal": "Увеличение числа клиентов\nи укрепление доверия\nаудитории в социальных\nсетях салона.",
        "task": "Администратор публикует сторис и посты\nпо контент-плану, согласованному с\nруководителем.",
        "formulation": "Размещение контента,\nбаллы",
        "explanation": "план по размещению\nконтента Y баллов ежедневно",
        "comments": "Учет контента:\n- Фото, соответствующие стандартам, получают 1 балл.\n- Сторис также оцениваются в 1 балл.\n- Посты приносят 2 или 3 балла, в зависимости от их качества и значимости."
    },
    {
        "area": "маркетинг",
        "num": 33,
        "goal": "Рост числа новых клиентов\nи повышение\nэффективности рекламных\nвложений. Автоматизация\nпроцессов взаимодействия\nс внешними SMM-\nспециалистами.",
        "task": "Улучшить взаимодействие между\n(Старшим) Администратором и SMM-\nспециалистом.\nУвеличить количество новых клиентов,\nпривлеченных через рекламные\nкампании с XX до YY за смену.",
        "formulation": "Клиент с рекламы, кл",
        "explanation": "запись YY клиентов по\nвходящим обращениям по\nрекламной компании",
        "comments": "Количество фактических записей по рекламной кампании \"Z\" легко определить в системе, если\nприсвоить ей уникальную услугу с названием, например, \"НЮД 970 руб\".\nНазначьте старшему администратору задачу по контролю количества записей в день по\nрекламной кампании. Дайте администратору полномочия представлять интересы салона и при\nнедостаточном количестве или качестве входящих лидов обращаться к SMM-специалисту для\nулучшения конверсии с помощью креативов и настройки аудитории."
    },
    {
        "area": "маркетинг",
        "num": 34,
        "goal": "Понимание состава\nклиентской базы салона и их\nпотребностей.",
        "task": "Сбор информации о клиенте посредством\nанкетирования. Это может быть как\nсплошное анкетирование, так и опрос\nпредставителей конкретных целевых\nгрупп.)",
        "formulation": "Анкетирование, кл",
        "explanation": "Провести анкетирование\nсреди YY клиентов за смену",
        "comments": "При составлении анкеты рекомендуется использовать вопросы с готовыми вариантами ответов\nдля удобства систематизации данных. Однако важно также включить хотя бы один вопрос,\nтребующий развернутого ответа."
    },
    {
        "area": "администрация",
        "num": 35,
        "goal": "исполнение стандартов",
        "task": "Мотивировать администратора\nполностью соответствовать стандартам в\nсвою смену: протоколы стерилизации,\nстандарты чистоты, гостеприимства,\nпродаж и другие.",
        "formulation": "100% Стандарт, баллы",
        "explanation": "выполнение 100% стандарта\nв смену, баллы",
        "comments": "1. Составить единый чек-лист для описания стандартов по каждому блоку.\n2. Провести проверку стандартов с помощью технологии \"тайный покупатель\" или руководителем\nпо чек-листу.\n3. Оценивать выполнение стандартов, сравнивая фактическое количество баллов с плановым."
    },
    {
        "area": "администрация",
        "num": 36,
        "goal": "внедрение CRM",
        "task": "обеспечить 100% отражение всех\nоказанных услуг в CRM",
        "formulation": "Услуги в CRM, %",
        "explanation": "План по 100% проведенным\nуслугам в CRM, %",
        "comments": "Контроль проводок оплат и обработки каждой записи в смене. Применять задачу на стадии\nвнедрения CRM, чтобы преодолеть сопротивление Администраторов и добиться быстрого 100%\nвнедрения.\nСчитать % от общего количества услуг"
    },
    {
        "area": "администрация",
        "num": 37,
        "goal": "улучшение качества\nоперативного управления",
        "task": "Стимулировать Администратора к\nсамостоятельному решению всех\nпроблем и ситуаций, возникающих в\nсмене, без необходимости обращения к\nРуководителю.",
        "formulation": "Оценка руководителя,\nбаллы",
        "explanation": "Оценка руководителя по\nвыполнению иных задач,\nплан 3 балла",
        "comments": "Комплексная оценка от руководителя включает следующие критерии:\n* Работа в команде\n* Клиентоориентированность\n* Своевременность и качество выполнения задач\n* Инновации и улучшения\nПлан 3 балла\nОценка по шкале:\n1 — неудовлетворительно\n2 — требует улучшения\n3 — полностью соответствует ожиданиям\n4 — превосходит ожидания\n5 — значительно превосходит ожидания\nЭтот универсальный показатель позволяет обобщённо оценить качество работы администратора\nв различных функциях. Для более детального анализа конкретной функции лучше выбрать\nузконаправленную задачу."
    },
    {
        "area": "финансы",
        "num": 38,
        "goal": "Сократить потери по статье\n«материалы» и\nавтоматизировать процесс\nразмещения заказов на\nматериалы и расходники.",
        "task": "Назначить ответственного\nАдминистратора за ведение склада;\nсвоевремое размещение заказов на\nматериалы и расходники; удержание\nрасходов на эту статью в рамках\nвыделенного бюджета. Снижение\nбюджета на материалы с ХХ до YY% от\nсреднемесячного оборота.",
        "formulation": "Оценка руководителя /\nСклад, баллы",
        "explanation": "Оценка руководителя по\nвыполнению функционала\nответсвенного за материалы.\nПлан -3 балла",
        "comments": "Оценка выполнения включает:\n- Наличие материалов и расходников каждую смену без перебоев.\n- Ежемесячные закупки в рамках бюджета.\n- Актуальность технологических карт в CRM.\n- Допустимые расхождения по инвентаризации и своевременное выполнение задач.\nКритерии оценки:\n1 — неудовлетворительно,\n2 — требует улучшения,\n3 — соответствует ожиданиям,\n4 — превосходит ожидания,\n5 — значительно превосходит ожидания."
    }
]
